import * as yup from "utils/yup";

import { INVALID_EMAIL_ADDRESS } from "../../../constants/errors";

import type { ObjectValuesAsType } from "utils/types";

import type { UserForm } from "../models/UserForm";

export type OrderableColumns = "email" | "name";

export const MAX_USER_NAME_LENGTH = 100;

export const USER_TYPE = {
  STANDARD_USER: "standard_user",
  OWNER: "owner",
  VOLT_ADMIN: "volt_admin",
} as const;

export const USER_TYPE_LIST: UserType[] = [
  USER_TYPE.STANDARD_USER,
  USER_TYPE.OWNER,
  USER_TYPE.VOLT_ADMIN,
];

export type UserType = ObjectValuesAsType<typeof USER_TYPE>;

export const USER_EDIT_SCHEMA = yup.object().shape({
  name: yup.string().required().max(MAX_USER_NAME_LENGTH),
  email: yup.string().required().validateEmailRFC5322(INVALID_EMAIL_ADDRESS),
  permissions: yup.array(yup.string()).nullable(),
  customer: yup.string().when("voltEmployee", {
    is: true,
    then: (schema) => schema,
    otherwise: (schema) =>
      schema.when("owner", {
        is: true,
        then: (schema) => schema,
        otherwise: (schema) => schema.required(),
      }),
  }),
}) as yup.ObjectSchema<UserForm>;

export const USER_CREATE_SCHEMA = yup.object().shape({
  name: yup.string().required().max(MAX_USER_NAME_LENGTH),
  email: yup.string().required().validateEmailRFC5322(INVALID_EMAIL_ADDRESS),
  permissions: yup.array(yup.string()).nullable(),
  customer: yup.string().when("voltEmployee", {
    is: true,
    then: (schema) => schema,
    otherwise: (schema) => schema.required(),
  }),
}) as yup.ObjectSchema<UserForm>;
